module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [(_vm.showFacebookPixel) ? _c('img', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "src": "https://www.facebook.com/tr?id=1442556416455138&ev=PageView&noscript=1"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "subscription-summary"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md9": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Thank you, " + _vm._s(_vm.user.FirstName) + " " + _vm._s(_vm.user.LastName))]), _vm._v(" "), (_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h4', [_vm._v("You're officially part of the MORvies Club!")]), _vm._v(" "), _c('p', [_vm._v("Check your mails. We'll be sending your eCard, which you can use to redeem your SK MORvies Club benefits when booking online.")])] : [_c('h4', [_vm._v("You're officially part of the Fan Club!")]), _vm._v(" "), _c('p', [_vm._v("Check your mails. We'll be sending your eCard, which you can use to redeem your SK Fan Club benefits when booking online.")])]], 2), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('sk-button', {
    staticClass: "subs-summary-dashboard-link",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToDashboard()
      }
    }
  }, [_vm._v("VIEW MY DASHBOARD")])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.subsClub.item != undefined) ? [(_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h3', [_vm._v("Unlimited movie tickets per month")]), _vm._v(" "), _c('h5', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                Watch up to 5 movies a day, every day!\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                                1 ticket per movie per card holder\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                20% off a regular combo\n                                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")]), _vm._v(" "), _c('br')])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md4": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToBook()
      }
    }
  }, [_vm._v("BOOK WITH SK MORVIES CLUB")])], 1)], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', [_vm._v("Limited movies per month")]), _vm._v(" "), _c('h5', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    You watch more for less\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    Use one or all four tickets at once\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    20% off a regular combo\n                                                ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sx12": "",
      "md4": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs)
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToBook()
      }
    }
  }, [_vm._v("BOOK WITH SK FAN CLUB")])], 1)], 1)] : _vm._e()]] : _vm._e()], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f69528b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/subscribe-process/subscribe-process.vue
// module id = 710
// module chunks = 0